import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";

import Hero from "./components/Hero/hero";
import Sobre from "./components/Sobre/sobre";
import MetodoApice from "./components/MetodoApice/metodoApice";
import Diagnostico from "./components/Diagnostico/diagnostico";
import Contato from "./components/Contato/contato";
import Footer from "./components/Footer/footer";
import Resultados from "./components/Resultados/resultados";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Hero />
                <Sobre />
                <Resultados />
                <Contato />
                <Footer />
              </>
            }
          />
          <Route
            path="/metodo-apice"
            element={
              <>
                <MetodoApice />
                <Footer />
              </>
            }
          />
          <Route
            path="/diagnostico"
            element={
              <>
                <Diagnostico />
                <Footer />
              </>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
